export default __webpack_public_path__ + "static/media/dhawal.2018d987.jpg";